export default [
  {
    name: "Training",
    icon: "model_training",
    to: "/training",
    enabled: true,
  },
];
